/* -------------------------------------------------------------------------
   TPS menu. 2026-09-18

   Two jobs:
     1. Dismiss behaviour for the popped-out panel.
     2. An Account link at the foot of the menu.
   ------------------------------------------------------------------------- */
(function () {
  var det = document.getElementById('Details-menu-drawer-container');
  if (!det) return;

  var summary = det.querySelector('summary');
  if (!summary) return;

  /* ---------------------------------------------------------------------
     1. Dismiss behaviour

     The panel floats clear of the page edges, so there is real page visible
     around it and clicking there should close it. Horizon renders a
     .menu-drawer__backdrop over the page but never wires it up, and it ships
     no Escape handler either.

     Closing goes through the <summary> rather than setting details.open, so
     the theme's own toggle logic runs and the body scroll lock is released.
     --------------------------------------------------------------------- */
  function close() {
    if (det.open) summary.click();
  }

  var backdrop = det.querySelector('.menu-drawer__backdrop');
  if (backdrop) {
    /* Horizon opens the menu on pointerdown, so the backdrop appears under
       the cursor before the matching click lands. Arming on a press that
       STARTED on the backdrop keeps the opening click from closing it. */
    var armed = false;

    backdrop.addEventListener('pointerdown', function () {
      armed = true;
    });

    backdrop.addEventListener('click', function () {
      var wasArmed = armed;
      armed = false;
      if (wasArmed) close();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') close();
  });

  /* ---------------------------------------------------------------------
     2. The Account link

     There is currently no way for a customer to reach the login. /account
     works and redirects to Shopify's hosted customer accounts, but nothing
     on the storefront links to it: Mayank's 2026-08-03 spec removed the
     profile icon from the header, and no replacement entry point was added.
     His spec says a logged-in customer's NAME shows inside this menu, so the
     menu is the right home for it.

     Injected here rather than added to the Shopify navigation on purpose.
     Shopify menus are STORE level, so adding "Account" to Pre-Launch Nav
     would appear on the live site immediately, and the live theme is frozen.
     A theme asset stays with this theme until it is published.

     TODO before launch: move this into blocks/_header-menu.liquid so the
     link is server rendered rather than depending on JS.
     --------------------------------------------------------------------- */
  var list = det.querySelector('.menu-drawer__menu');
  if (!list || list.querySelector('[data-tps-account]')) return;

  var item = document.createElement('li');
  item.className = 'menu-drawer__list-item--flat';
  item.setAttribute('data-tps-account', '');

  var link = document.createElement('a');
  link.href = '/account';
  link.className =
    'menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element';

  var text = document.createElement('span');
  text.className = 'menu-drawer__menu-item-text wrap-text';
  text.textContent = 'Account';

  link.appendChild(text);
  item.appendChild(link);
  list.appendChild(item);
})();
